import { PharmacySelect, PharmacyPagination, PharmacyMetric } from './shared/PharmacyUI';
import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import './shared/ReporteConteo.css';
import { Inventory2Outlined, TaskAltRounded, LayersOutlined, BlockRounded } from '@mui/icons-material';
import { Box, Typography, CircularProgress, Tooltip, Dialog, Popover, Alert } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { authService } from '../services/api';
import api from '../services/api';
import { HeaderIOS, IOS as BaseIOS } from './shared/MenuLayout';

const IOS = { ...BaseIOS, blue:'#548EE6', green:'#59AE88', purple:'#9380CD', red:'#D66F7C', orange:'#D99C55', separator:'#E7ECF3' };

const fmtFecha = (s) => {
  if (!s) return '—';
  const d = new Date(s);
  return isNaN(d) ? s : d.toLocaleDateString('es-PE', { day: '2-digit', month: '2-digit', year: 'numeric' });
};
const fmtHora = (s) => {
  if (!s) return '';
  const d = new Date(s);
  return isNaN(d) ? '' : d.toLocaleTimeString('es-PE', { hour: '2-digit', minute: '2-digit' });
};
const primerDiaMes = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-01`;
};
const hoy = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};

const Lbl = ({ children }) => (
  <Typography sx={{ fontSize: '0.72rem', fontWeight: 700, color: IOS.label2, letterSpacing: '0.07em', textTransform: 'uppercase', mb: 0.5 }}>{children}</Typography>
);

const Sel = PharmacySelect;

const DIAS_SEMANA = ['D','L','M','M','J','V','S'];
const MESES_LARGO = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];
const toYMD = (d) => `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
const parseYMD = (s) => { if(!s) return new Date(); const [y,m,d] = s.split('-').map(Number); return new Date(y, m-1, d); };

const DatePickerIOS = ({ value, onChange, w='100%', label }) => {
  const [open, setOpen] = useState(false);
  
  const ref = useRef(null);
  
  const selDate = value ? parseYMD(value) : null;
  const [viewMonth, setViewMonth] = useState(selDate ? selDate.getMonth() : new Date().getMonth());
  const [viewYear, setViewYear] = useState(selDate ? selDate.getFullYear() : new Date().getFullYear());

  const handleOpen = () => {

    if (selDate) { setViewMonth(selDate.getMonth()); setViewYear(selDate.getFullYear()); }
    setOpen(v=>!v);
  };

  const cambiarMes = (delta) => {
    let m = viewMonth + delta, y = viewYear;
    if (m < 0) { m = 11; y--; } else if (m > 11) { m = 0; y++; }
    setViewMonth(m); setViewYear(y);
  };

  const elegirDia = (dia) => { onChange(toYMD(new Date(viewYear, viewMonth, dia))); setOpen(false); };

  const hoyD = new Date();
  const primerDiaSemana = new Date(viewYear, viewMonth, 1).getDay();
  const totalDias = new Date(viewYear, viewMonth+1, 0).getDate();
  const celdas = [...Array(primerDiaSemana).fill(null), ...Array.from({length:totalDias},(_,i)=>i+1)];
  const labelFecha = selDate ? `${String(selDate.getDate()).padStart(2,'0')}/${String(selDate.getMonth()+1).padStart(2,'0')}/${selDate.getFullYear()}` : '';

  return (
    <Box ref={ref} sx={{ position:'relative', width:w }}>
      <Box component="button" type="button" aria-label={label} aria-haspopup="dialog" aria-expanded={open} className="conteo-date-trigger" onClick={handleOpen}
        sx={{ width:'100%', height:44, px:1.2, display:'flex', alignItems:'center', gap:0.8,
          border:`1px solid ${open?IOS.blue:IOS.separator}`, borderRadius:'8px',
          bgcolor:IOS.surface, cursor:'pointer', userSelect:'none',
          boxShadow:open?`0 0 0 3px ${IOS.blue}18`:'none', transition:'all 0.15s', boxSizing:'border-box' }}>
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke={IOS.label2} strokeWidth="2" strokeLinecap="round">
          <rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
        </svg>
        <Typography sx={{ fontSize:'0.8rem', color:IOS.label, flex:1, whiteSpace:'nowrap' }}>{labelFecha}</Typography>
      </Box>

      <Popover open={open} anchorEl={ref.current} onClose={() => setOpen(false)} anchorOrigin={{vertical:"bottom",horizontal:"left"}} transformOrigin={{vertical:"top",horizontal:"left"}} transitionDuration={0} disableScrollLock PaperProps={{className:"conteo-calendar", sx:{borderRadius:"20px", mt:1}}}>
        <Box role="dialog" aria-label={`Elegir fecha: ${label}`} sx={{
          bgcolor:IOS.surface, border:`1px solid ${IOS.separator}`, borderRadius:'14px',
          boxShadow:'0 8px 24px rgba(0,0,0,0.16)', width:260, p:1.5 }}>

          <Box className="pharmacy-layout" sx={{ display:'flex', alignItems:'center', justifyContent:'space-between', mb:1 }}>
            <Box className="pharmacy-layout pharmacy-action" component="button" aria-label="Mes anterior" onClick={()=>cambiarMes(-1)}
              sx={{ width:26, height:26, borderRadius:'8px', border:'none', bgcolor:IOS.bg, cursor:'pointer',
                display:'flex', alignItems:'center', justifyContent:'center' }}>
              <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke={IOS.label} strokeWidth="3" strokeLinecap="round"><polyline points="15 18 9 12 15 6"/></svg>
            </Box>
            <Typography sx={{ fontSize:'0.82rem', fontWeight:700, color:IOS.label }}>{MESES_LARGO[viewMonth]} {viewYear}</Typography>
            <Box className="pharmacy-layout pharmacy-action" component="button" aria-label="Mes siguiente" onClick={()=>cambiarMes(1)}
              sx={{ width:26, height:26, borderRadius:'8px', border:'none', bgcolor:IOS.bg, cursor:'pointer',
                display:'flex', alignItems:'center', justifyContent:'center' }}>
              <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke={IOS.label} strokeWidth="3" strokeLinecap="round"><polyline points="9 18 15 12 9 6"/></svg>
            </Box>
          </Box>

          <Box className="pharmacy-layout" sx={{ display:'grid', gridTemplateColumns:'repeat(7,1fr)', mb:0.5 }}>
            {DIAS_SEMANA.map((d,i)=>(<Typography key={i} sx={{ fontSize: '0.72rem', fontWeight:700, color:IOS.label2, textAlign:'center' }}>{d}</Typography>))}
          </Box>

          <Box className="pharmacy-layout" sx={{ display:'grid', gridTemplateColumns:'repeat(7,1fr)', gap:'2px' }}>
            {celdas.map((dia,i)=>{
              if (dia===null) return <Box key={i} />;
              const esHoy = dia===hoyD.getDate() && viewMonth===hoyD.getMonth() && viewYear===hoyD.getFullYear();
              const esSel = selDate && dia===selDate.getDate() && viewMonth===selDate.getMonth() && viewYear===selDate.getFullYear();
              return (
                <Box component="button" type="button" aria-label={`${dia} de ${MESES_LARGO[viewMonth]} de ${viewYear}`} aria-pressed={!!esSel} className="pharmacy-layout" key={i} onClick={()=>elegirDia(dia)}
                  sx={{ height:30, display:'flex', alignItems:'center', justifyContent:'center', borderRadius:'8px', cursor:'pointer',
                    bgcolor:esSel?IOS.blue:'transparent',
                    border:esHoy&&!esSel?`1.5px solid ${IOS.blue}`:'none' }}>
                  <Typography sx={{ fontSize:'0.78rem', fontWeight:esSel?700:500, color:esSel?'white':IOS.label }}>{dia}</Typography>
                </Box>
              );
            })}
          </Box>
        </Box>
      </Popover>
    </Box>
  );
};

const TH = ({ children, right, center, w }) => (
  <th style={{
    padding: '9px 8px', width: w || 'auto', textAlign: right ? 'right' : center ? 'center' : 'left',
    fontSize: '0.72rem', fontWeight: 700, color: IOS.label2, letterSpacing: '0.06em', textTransform: 'uppercase',
    backgroundColor: IOS.surface, borderBottom: `1px solid ${IOS.separator}`, whiteSpace: 'nowrap',
    position: 'sticky', top: 0, zIndex: 1
  }}>{children}</th>
);

const PillEstado = ({ estado }) => {
  const cfg = estado === 'CERRADO'
    ? { bg: '#EDFAF2', bdr: '#B7EFD0', dot: IOS.green, txt: '#1A6B3C' }
    : estado === 'ANULADO'
      ? { bg: '#FFF0EF', bdr: '#FFD4D1', dot: IOS.red, txt: '#C0392B' }
      : { bg: '#FFF8E6', bdr: '#FFE9A0', dot: IOS.orange, txt: '#8B6914' };
  return (
    <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5, px: 0.8, py: 0.2, borderRadius: '20px', bgcolor: cfg.bg, border: `1px solid ${cfg.bdr}` }}>
      <Box sx={{ width: 4, height: 4, borderRadius: '50%', bgcolor: cfg.dot, flexShrink: 0 }} />
      <Typography sx={{ fontSize: '0.72rem', fontWeight: 700, color: cfg.txt, whiteSpace: 'nowrap' }}>{estado}</Typography>
    </Box>
  );
};

const Modal = ({ open, onClose, children, w = 460 }) => (
  <Dialog open={open} onClose={onClose} maxWidth={false} aria-labelledby="conteo-modal-title"
    PaperProps={{className:'pharmacy-page conteo-page conteo-dialog', sx:{width:w,maxWidth:'calc(100vw - 24px)',maxHeight:'calc(100dvh - 24px)',m:1.5,borderRadius:'24px',overflowY:'auto'}}}>
    {children}
  </Dialog>
);

const ModalHeader = ({ title, onClose, icon, color = IOS.blue, badge }) => (
  <Box className="pharmacy-layout" sx={{ px: 2.5, pt: 2.5, pb: 2, borderBottom: `1px solid ${IOS.separator}`, flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
    <Box className="pharmacy-layout" sx={{ display: 'flex', alignItems: 'center', gap: 1.2 }}>
      <Box className="pharmacy-layout" sx={{ width: 32, height: 32, borderRadius: '10px', bgcolor: `${color}15`, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{icon}</Box>
      <Typography id="conteo-modal-title" component="h2" sx={{ fontWeight: 700, fontSize: '0.92rem', color: IOS.label }}>{title}</Typography>
      {badge > 0 && (
        <Box sx={{ px: 1, py: 0.2, borderRadius: '20px', bgcolor: `${color}15`, border: `1px solid ${color}30` }}>
          <Typography sx={{ fontSize: '0.72rem', fontWeight: 700, color }}>{badge} productos</Typography>
        </Box>
      )}
    </Box>
    <Box className="pharmacy-layout pharmacy-action" component="button" aria-label="Cerrar ventana" onClick={onClose} sx={{ width: 28, height: 28, borderRadius: '50%', border: 'none', bgcolor: '#E5E5EA', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', '&:hover': { bgcolor: '#D1D1D6' } }}>
      <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke={IOS.label} strokeWidth="2.5" strokeLinecap="round"><path d="M18 6L6 18M6 6l12 12" /></svg>
    </Box>
  </Box>
);

const Paginacion = PharmacyPagination;

// ── Modal Dividir ─────────────────────────────────────────────────────────────
const ModalDividir = ({ open, onClose, fila, ueId, onPdfGenerado }) => {
  const [quimicos, setQuimicos] = useState(2);
  const [generando, setGenerando] = useState(false);
  const [error, setError] = useState('');
  useEffect(() => { if (open) setError(''); }, [open]);

  const opciones = [2, 3, 4, 5, 6];

  const generar = async () => {
    if (!fila || generando) return;
    setGenerando(true); setError('');
    try {
      const r = await api.get('/farmacia/reporte-conteo/dividir-pdf', {
        params: { fcdId: fila.FCD_ID, quimicos },
        responseType: 'blob'
      });
      const url = URL.createObjectURL(new Blob([r.data], { type: 'application/pdf' }));
      onClose();
      onPdfGenerado(url, fila);
    } catch (e) { setError('No se pudo generar el PDF. Inténtalo nuevamente.'); }
    finally { setGenerando(false); }
  };

  return (
    <Modal open={open} onClose={() => !generando && onClose()} w={420}>
      <ModalHeader
        title="Dividir reporte entre personal"
        onClose={() => !generando && onClose()}
        color={IOS.purple}
        icon={<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={IOS.purple} strokeWidth="2" strokeLinecap="round"><path d="M16 3h5v5M4 20L21 3M21 16v5h-5M15 15l6 6M4 4l5 5" /></svg>}
      />
      <Box sx={{ p: 2.5 }}>
        {fila && (
          <Box sx={{ p: 1.5, bgcolor: IOS.bg, borderRadius: '10px', border: `1px solid ${IOS.separator}`, mb: 2 }}>
            <Typography sx={{ fontSize: '0.7rem', color: IOS.label2 }}>Conteo <strong style={{ color: IOS.label }}>#{fila.FCD_ID}</strong> — {fila.FECHA_CONSULTADA}</Typography>
          </Box>
        )}

        {/* Explicación */}
        <Box sx={{ p: 1.5, bgcolor: `${IOS.purple}08`, borderRadius: '10px', border: `1px solid ${IOS.purple}20`, mb: 2 }}>
          <Typography sx={{ fontSize: '0.72rem', color: IOS.purple, fontWeight: 600, mb: 0.5 }}>¿Cómo funciona?</Typography>
          <Typography sx={{ fontSize: '0.7rem', color: IOS.label2, lineHeight: 1.6 }}>
            El reporte se divide equitativamente agrupando primero por <strong>Medicamentos (M)</strong> y luego por <strong>Insumos (I)</strong>. Cada persona recibe su sección de M y su sección de I en un solo PDF.
          </Typography>
        </Box>

        {/* Selector de químicos */}
        <Typography sx={{ fontSize: '0.72rem', fontWeight: 700, color: IOS.label2, textTransform: 'uppercase', letterSpacing: '0.07em', mb: 1 }}>¿Entre cuántas personas?</Typography>
        <Box className="pharmacy-layout" sx={{ display: 'flex', gap: 0.8, mb: 2.5, flexWrap: 'wrap' }}>
          {opciones.map(n => (
            <Box component="button" type="button" aria-pressed={quimicos === n} aria-label={`${n} personas`} className="pharmacy-layout" key={n} onClick={() => setQuimicos(n)}
              sx={{
                width: 52, height: 52, borderRadius: '12px', cursor: 'pointer',
                border: `2px solid ${quimicos === n ? IOS.purple : IOS.separator}`,
                bgcolor: quimicos === n ? `${IOS.purple}08` : IOS.bg,
                display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                transition: 'all 0.15s', '&:hover': { borderColor: IOS.purple }
              }}>
              <Typography sx={{ fontSize: '1.2rem', fontWeight: 800, color: quimicos === n ? IOS.purple : IOS.label, lineHeight: 1 }}>{n}</Typography>
              <Typography sx={{ fontSize: '0.72rem', color: IOS.label2, mt: 0.2 }}>pers.</Typography>
            </Box>
          ))}
        </Box>

        {/* Preview distribución */}
        <Box sx={{ p: 1.5, bgcolor: IOS.bg, borderRadius: '10px', border: `1px solid ${IOS.separator}`, mb: 2.5 }}>
          <Typography sx={{ fontSize: '0.72rem', fontWeight: 700, color: IOS.label2, textTransform: 'uppercase', letterSpacing: '0.07em', mb: 1 }}>Estructura del PDF</Typography>
          <Box className="pharmacy-layout" sx={{ display: 'flex', flexDirection: 'column', gap: 0.6 }}>
            {Array.from({ length: quimicos }, (_, i) => (
              <Box className="pharmacy-layout" key={i} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Box className="pharmacy-layout" sx={{ width: 20, height: 20, borderRadius: '6px', bgcolor: `${IOS.purple}15`, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                  <Typography sx={{ fontSize: '0.72rem', fontWeight: 700, color: IOS.purple }}>{i + 1}</Typography>
                </Box>
                <Box className="pharmacy-layout" sx={{ display: 'flex', gap: 0.5 }}>
                  <Box className="pharmacy-layout" sx={{ px: 0.8, py: 0.2, borderRadius: '6px', bgcolor: '#EDFAF2', border: '1px solid #B7EFD0', display: 'flex', alignItems: 'center', gap: 0.4 }}>
                    <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#1A6B3C" strokeWidth="2.2" strokeLinecap="round">
                      <path d="M10.5 20.5L3.5 13.5a5 5 0 0 1 7-7l7 7a5 5 0 0 1-7 7z"/><path d="M8.5 8.5l7 7"/>
                    </svg>
                    <Typography sx={{ fontSize: '0.72rem', fontWeight: 600, color: '#1A6B3C' }}>Medicamentos</Typography>
                  </Box>
                  <Box className="pharmacy-layout" sx={{ px: 0.8, py: 0.2, borderRadius: '6px', bgcolor: `${IOS.orange}10`, border: `1px solid ${IOS.orange}30`, display: 'flex', alignItems: 'center', gap: 0.4 }}>
                    <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke={IOS.orange} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M21 8l-9-5-9 5v8l9 5 9-5V8z"/><path d="M3 8l9 5 9-5"/><path d="M12 13v8"/>
                    </svg>
                    <Typography sx={{ fontSize: '0.72rem', fontWeight: 600, color: IOS.orange }}>Insumos</Typography>
                  </Box>
                </Box>
              </Box>
            ))}
          </Box>
        </Box>

        {error && <Alert severity="error" sx={{mb:2,borderRadius:2}}>{error}</Alert>}
        {/* Botón generar */}
        <Box className="pharmacy-layout pharmacy-action" component="button" onClick={generar} disabled={generando}
          sx={{
            width: '100%', height: 40, borderRadius: '12px', border: 'none',
            bgcolor: generando ? '#E5E5EA' : IOS.purple,
            cursor: generando ? 'default' : 'pointer',
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1,
            transition: 'all 0.2s', '&:hover': { filter: generando ? 'none' : 'brightness(0.92)' }
          }}>
          {generando
            ? <Box sx={{ width: 14, height: 14, borderRadius: '50%', border: '2px solid rgba(255,255,255,0.3)', borderTopColor: 'white', animation: 'spin 0.8s linear infinite', '@keyframes spin': { '0%': { transform: 'rotate(0deg)' }, '100%': { transform: 'rotate(360deg)' } } }} />
            : <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.2" strokeLinecap="round"><path d="M12 3v13M7 11l5 5 5-5" /><path d="M4 20h16" /></svg>
          }
          <Typography sx={{ fontSize: '0.88rem', fontWeight: 700, color: generando ? '#8E8E93' : 'white' }}>
            {generando ? 'Generando PDF...' : `Generar — ${quimicos} personas`}
          </Typography>
        </Box>
      </Box>
    </Modal>
  );
};

// ══════════════════════════════════════════════════════════════════════════════
const BtnAcc = ({ onClick, color, bg, hoverBg, title, disabled, icon }) => (
    <Tooltip title={title} placement="top">
      <Box component="button" type="button" aria-label={title} disabled={disabled} onClick={disabled ? undefined : onClick}
        sx={{ border:0, width: 36, height: 36, borderRadius: '11px', bgcolor: bg, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', cursor: disabled ? 'default' : 'pointer', opacity: disabled ? 0.3 : 1, transition: 'all 0.15s', '&:hover': { bgcolor: disabled ? bg : hoverBg } }}>
        {icon}
      </Box>
    </Tooltip>
  );

const ReporteConteo = ({ modulo = 'farmacia' }) => {
  const navigate = useNavigate();
  const user = authService.getCurrentUser();
  const idEstab = user?.idEstablecimiento || user?.IdEstablecimiento || 0;
  const ueId = user?.ueIdEstablecimiento || user?.UeIdEstablecimiento || 0;
  const privilegio = (user?.privilegio || '').toUpperCase();
  const esTOTAL = privilegio === 'TOTAL';
  const nf = user?.nombreCompleto || user?.usuario || '';
  const handleLogout = () => { authService.logout(); navigate('/login'); };

  const [fechaInicio, setFechaInicio] = useState(primerDiaMes());
  const [fechaFin, setFechaFin] = useState(hoy());
  const [datos, setDatos] = useState([]);
  const [busqueda, setBusqueda] = useState('');
  const [estadoFiltro, setEstadoFiltro] = useState('TODOS');
  const [errorListado, setErrorListado] = useState('');
  const [cargando, setCargando] = useState(false);
  const [pagina, setPagina] = useState(1);
  const [rpp, setRpp] = useState(() => window.matchMedia('(max-width:600px)').matches ? 10 : 20);

  const [listaIpress, setListaIpress] = useState([]);
  const [ipressSel, setIpressSel] = useState(String(idEstab));

  const [modalResumen, setModalResumen] = useState(false);
  const [filaSelec, setFilaSelec] = useState(null);
  const [resumen, setResumen] = useState([]);
  const [cargRes, setCargRes] = useState(false);
  const [busqRes, setBusqRes] = useState('');

  const [modalPrint, setModalPrint] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [cargDet, setCargDet] = useState(false);
  useEffect(() => () => { if (pdfUrl) URL.revokeObjectURL(pdfUrl); }, [pdfUrl]);

  const [modalAnular, setModalAnular] = useState(false);
  const [anulando, setAnulando] = useState(false);
  const [filaAnular, setFilaAnular] = useState(null);

  // ── NUEVO: modal dividir ───────────────────────────────────────────────
  const [modalDividir, setModalDividir] = useState(false);
  const [filaDividir, setFilaDividir] = useState(null);

  useEffect(() => {
    if (!esTOTAL) return;
    api.get('/farmacia/reporte-conteo/ipress', { params: { idEjecutora: ueId } })
      .then(r => { if (r.data.success) { setListaIpress(r.data.data || []); if (idEstab) setIpressSel(String(idEstab)); } })
      .catch(console.error);
  }, [esTOTAL, ueId, idEstab]);

  const idEstabActual = esTOTAL ? Number(ipressSel) || idEstab : idEstab;

  const cargar = useCallback(async () => {
    if (fechaInicio > fechaFin) { setDatos([]); setErrorListado("La fecha inicial debe ser anterior o igual a la final."); return; }
    setCargando(true); setErrorListado('');
    try {
      const r = await api.get('/farmacia/reporte-conteo/listar', { params: { idEstablecimiento: idEstabActual, fechaInicio, fechaFin } });
      if (r.data.success) { setDatos(r.data.data || []); setPagina(1); }
      else { setDatos([]); setErrorListado(r.data.message || 'No se pudieron cargar los conteos.'); }
    } catch (e) { setDatos([]); setErrorListado('No se pudieron cargar los conteos. Vuelve a consultar.'); } finally { setCargando(false); }
  }, [idEstabActual, fechaInicio, fechaFin]);

  useEffect(() => { cargar(); }, [cargar]);

  const verResumen = async (fila) => {
    setFilaSelec(fila); setResumen([]); setCargRes(true); setBusqRes(''); setModalResumen(true);
    try {
      const r = await api.get('/farmacia/reporte-conteo/resumen', { params: { fcdId: fila.FCD_ID } });
      if (r.data.success) setResumen(r.data.data || []);
    } catch (e) { console.error(e); } finally { setCargRes(false); }
  };

  const verImpresion = async (fila) => {
    setFilaSelec(fila); setPdfUrl(null); setCargDet(true); setModalPrint(true);
    try {
      const r = await api.get('/farmacia/reporte-conteo/imprimir-pdf', { params: { fcdId: fila.FCD_ID }, responseType: 'blob' });
      setPdfUrl(URL.createObjectURL(new Blob([r.data], { type: 'application/pdf' })));
    } catch (e) { console.error(e); setModalPrint(false); } finally { setCargDet(false); }
  };

  const confirmarAnular = async () => {
    if (!filaAnular) return;
    setAnulando(true);
    try {
      const r = await api.post('/farmacia/reporte-conteo/anular', { fcdId: filaAnular.FCD_ID });
      if (r.data.success) { setModalAnular(false); cargar(); }
      else alert(r.data.message || 'No se pudo anular');
    } catch (e) { console.error(e); } finally { setAnulando(false); }
  };

  const datosFiltrados = useMemo(() => datos.filter(row =>
    (estadoFiltro === 'TODOS' || row.ESTADO === estadoFiltro) &&
    [row.FCD_ID, row.TIPO, row.USUARIO_INTEGRA].some(value => String(value ?? '').toLocaleLowerCase().includes(busqueda.trim().toLocaleLowerCase()))
  ), [datos, estadoFiltro, busqueda]);
  useEffect(() => { setPagina(1); }, [busqueda, estadoFiltro]);
  const datosPag = datosFiltrados.slice((pagina - 1) * rpp, pagina * rpp);
  const estados = [...new Set(datos.map(row => row.ESTADO).filter(Boolean))];

  const resumenFiltrado = useMemo(() =>
    busqRes ? resumen.filter(r => (r.PRODUCTO || '').toLowerCase().includes(busqRes.toLowerCase()) || String(r.CODIGO || '').toLowerCase().includes(busqRes.toLowerCase())) : resumen
    , [resumen, busqRes]);

  const totRes = useMemo(() => ({
    INGRESOS: resumenFiltrado.reduce((a, x) => a + Number(x.INGRESOS || 0), 0),
    SALIDAS:  resumenFiltrado.reduce((a, x) => a + Number(x.SALIDAS || 0), 0),
    STOCK:    resumenFiltrado.reduce((a, x) => a + Number(x.STOCK || 0), 0),
  }), [resumenFiltrado]);



  return (
    <>
      <Box className="pharmacy-page conteo-page" sx={{ minHeight: '100vh', bgcolor: IOS.bg }}>
        <HeaderIOS titulo="Reporte de Conteo" subtitulo="Farmacia"
          onHome={() => navigate(`/${modulo}`)} onLogout={handleLogout}
          nombreCompleto={nf} avatarLetra={nf.charAt(0).toUpperCase()} />

        <Box className="pharmacy-content" sx={{ maxWidth: 1400, mx: 'auto', px: { xs: 1.5, sm: 2.6 }, pt: 2.5, pb: 6 }}>

          <div className="conteo-heading"><span>CONTROL DE INVENTARIO</span><h1>Reporte de conteo</h1><p>Consulta tus conteos, revisa movimientos y organiza el trabajo de tu equipo.</p></div>
          <div className="conteo-metrics">
            <PharmacyMetric Icon={Inventory2Outlined} label="Conteos del período" value={cargando ? '—' : datos.length} sub="En la IPRESS seleccionada" color={IOS.blue}/>
            <PharmacyMetric Icon={TaskAltRounded} label="Cerrados" value={cargando ? '—' : datos.filter(r=>r.ESTADO==='CERRADO').length} sub="Conteos finalizados" color={IOS.green}/>
            <PharmacyMetric Icon={LayersOutlined} label="Otros estados" value={cargando ? '—' : datos.filter(r=>!['CERRADO','ANULADO'].includes(r.ESTADO)).length} sub="Excluye cerrados y anulados" color={IOS.orange}/>
            <PharmacyMetric Icon={BlockRounded} label="Anulados" value={cargando ? '—' : datos.filter(r=>r.ESTADO==='ANULADO').length} sub="Sin impresión disponible" color={IOS.red}/>
          </div>
          {/* Filtros */}
          <Box className="pharmacy-layout pharmacy-toolbar pharmacy-card conteo-filters" sx={{ bgcolor: IOS.surface, borderRadius: '16px', p: 2, mb: 2, boxShadow: '0 1px 4px rgba(0,0,0,0.07)', border: `1px solid ${IOS.separator}`, display: 'flex', flexWrap: 'wrap', gap: 1.5, alignItems: 'flex-end' }}>
            {esTOTAL && (
              <Box>
                <Lbl>IPRESS</Lbl>
                <Sel aria-label="IPRESS" value={ipressSel} onChange={e => setIpressSel(e.target.value)} w="100%">
                  {listaIpress.map(ip => (
                    <option key={ip.ID_ESTABLECIMIENTO} value={String(ip.ID_ESTABLECIMIENTO)}>{ip.NOMBRE}</option>
                  ))}
                </Sel>
              </Box>
            )}
            {!esTOTAL && (
              <Box>
                <Lbl>IPRESS</Lbl>
                <Box className="pharmacy-layout" sx={{ height:34, px:1.5, display:'flex', alignItems:'center', border:`1px solid ${IOS.separator}`, borderRadius:8, bgcolor:IOS.bg, minWidth:220 }}>
                  <Typography sx={{ fontSize:'0.8rem', color:IOS.label2, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
                    {user?.ipress || 'Mi IPRESS'}
                  </Typography>
                </Box>
              </Box>
            )}
            {[['Desde', fechaInicio, setFechaInicio], ['Hasta', fechaFin, setFechaFin]].map(([lbl, val, set]) => (
              <Box key={lbl}>
                <Lbl>{lbl}</Lbl>
                <DatePickerIOS label={lbl} value={val} onChange={set} w="100%" />
              </Box>
            ))}
            <Box className="pharmacy-layout pharmacy-action" component="button" disabled={cargando} onClick={cargar}
              sx={{ height: 34, px: 2, borderRadius: '10px', border: 'none', bgcolor: IOS.blue, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 0.8, alignSelf: 'flex-end', transition: 'all 0.15s', '&:hover': { filter: 'brightness(0.9)' } }}>
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.2" strokeLinecap="round"><circle cx="11" cy="11" r="8" /><path d="M21 21l-4.35-4.35" /></svg>
              <Typography sx={{ fontSize: '0.8rem', fontWeight: 700, color: 'white' }}>Consultar</Typography>
            </Box>

          </Box>

          {errorListado && <Alert severity="error" sx={{mb:2,borderRadius:'16px'}}>{errorListado}</Alert>}
          <div className="conteo-list-toolbar"><div><h2>Historial de conteos</h2><p>{datosFiltrados.length} resultados · Revisa, imprime o distribuye un reporte.</p></div><div className="conteo-list-controls"><input aria-label="Buscar conteo" placeholder="Buscar ID, tipo o usuario…" value={busqueda} onChange={e=>setBusqueda(e.target.value)}/><Sel aria-label="Filtrar por estado" value={estadoFiltro} onChange={e=>setEstadoFiltro(e.target.value)} w="100%"><option value="TODOS">Todos los estados</option>{estados.map(e=><option key={e} value={e}>{e}</option>)}</Sel></div></div>
          {/* Tabla */}
          {cargando
            ? <Box sx={{ py: 10, textAlign: 'center' }}><CircularProgress sx={{ color: IOS.blue }} /></Box>
            : <Box className="pharmacy-card" sx={{ bgcolor: IOS.surface, borderRadius: '16px', boxShadow: '0 1px 4px rgba(0,0,0,0.07)', border: `1px solid ${IOS.separator}`, overflow: 'hidden' }}>
              <Box className="pharmacy-scroll" tabIndex={0} role="region" aria-label="Tabla de resultados, desplazamiento horizontal" sx={{ overflowX: 'auto', overflowY: 'auto', maxHeight: 580, '&::-webkit-scrollbar': { width: 4, height: 4 }, '&::-webkit-scrollbar-thumb': { bgcolor: IOS.separator, borderRadius: 4 } }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', tableLayout: 'fixed', minWidth: 980 }}>
                  <colgroup>
                    <col style={{ width: 50 }} /><col style={{ width: 85 }} /><col style={{ width: 140 }} />
                    <col style={{ width: 130 }} /><col style={{ width: 140 }} /><col style={{ width: 100 }} />
                    <col style={{ width: 80 }} /><col style={{ width: 180 }} />
                  </colgroup>
                  <thead><tr>
                    <TH center>#</TH><TH>ID</TH><TH>Tipo</TH>
                    <TH>Usuario</TH><TH>Fecha Creación</TH>
                    <TH>Fecha Conteo</TH><TH center>Estado</TH><TH center>Acciones</TH>
                  </tr></thead>
                  <tbody>
                    {datosPag.length === 0
                      ? <tr><td colSpan={8} style={{ padding: '40px', textAlign: 'center', color: IOS.label2, fontSize: '0.82rem' }}><strong>No hay conteos para mostrar</strong><br />Prueba otro período o ajusta la búsqueda.</td></tr>
                      : datosPag.map((row, i) => {
                        const bloqueado = row.ESTADO === 'ANULADO';
                        return (
                          <tr key={row.FCD_ID} className={row.FCD_ID === datos[0]?.FCD_ID ? 'conteo-recent-row' : undefined}
                            style={{ borderBottom: `1px solid ${IOS.separator}`, backgroundColor: IOS.surface, transition: 'background 0.1s' }}
                            onMouseEnter={e => e.currentTarget.style.backgroundColor = IOS.bg}
                            onMouseLeave={e => e.currentTarget.style.backgroundColor = IOS.surface}>
                            <td style={{ padding: '7px 8px', textAlign: 'center', fontSize: '0.72rem', color: IOS.label2 }}>{(pagina - 1) * rpp + i + 1}</td>
                            <td style={{ padding: '7px 8px', fontFamily: 'monospace', fontSize: '0.72rem', fontWeight: 700, color: IOS.blue }}>{row.FCD_ID}</td>
                            <td style={{ padding: '7px 8px', fontSize: '0.72rem', color: IOS.label }}>{row.TIPO}</td>
                            <td style={{ padding: '7px 8px', fontSize: '0.72rem', color: IOS.label2 }}>{row.USUARIO_INTEGRA}</td>
                            <td style={{ padding: '7px 8px', fontSize: '0.7rem', color: IOS.label2, whiteSpace: 'nowrap' }}>
                              {fmtFecha(row.FECHA_CREACION)} <span style={{ fontSize: '0.72rem' }}>{fmtHora(row.FECHA_CREACION)}</span>
                            </td>
                            <td style={{ padding: '7px 8px', fontSize: '0.7rem', color: IOS.label2 }}>{row.FECHA_CONSULTADA}</td>
                            <td style={{ padding: '7px 8px', textAlign: 'center' }}><PillEstado estado={row.ESTADO} /></td>
                            <td style={{ padding: '5px 6px', textAlign: 'center' }}>
                              <Box className="pharmacy-layout" sx={{ display: 'flex', gap: 0.5, justifyContent: 'center' }}>
                                {/* Ver resumen */}
                                <BtnAcc title="Ver resumen" color={IOS.blue} bg={`${IOS.blue}12`} hoverBg={`${IOS.blue}22`}
                                  onClick={() => verResumen(row)}
                                  icon={<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={IOS.blue} strokeWidth="2" strokeLinecap="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" /><circle cx="12" cy="12" r="3" /></svg>} />

                                {/* Imprimir normal */}
                                <BtnAcc
                                  title={bloqueado ? `No imprimible — ${row.ESTADO.toLowerCase()}` : 'Imprimir reporte completo'}
                                  color={IOS.green} bg={`${IOS.green}12`} hoverBg={`${IOS.green}22`}
                                  disabled={bloqueado}
                                  onClick={() => verImpresion(row)}
                                  icon={<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={IOS.green} strokeWidth="2" strokeLinecap="round"><polyline points="6 9 6 2 18 2 18 9" /><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" /><rect x="6" y="14" width="12" height="8" /></svg>} />

                                {/* ── NUEVO: Dividir entre químicos ── */}
                                <BtnAcc
                                  title={bloqueado ? `No disponible — ${row.ESTADO.toLowerCase()}` : 'Dividir entre químicos'}
                                  color={IOS.purple} bg={`${IOS.purple}12`} hoverBg={`${IOS.purple}22`}
                                  disabled={bloqueado}
                                  onClick={() => { setFilaDividir(row); setModalDividir(true); }}
                                  icon={<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={IOS.purple} strokeWidth="2" strokeLinecap="round"><path d="M16 3h5v5M4 20L21 3M21 16v5h-5M15 15l6 6M4 4l5 5" /></svg>} />

                                {/* Anular */}
                                <BtnAcc
                                  title={bloqueado ? `No anulable — ${row.ESTADO.toLowerCase()}` : 'Anular'}
                                  color={IOS.red} bg='#FFF0EF' hoverBg='#FFD4D1'
                                  disabled={bloqueado}
                                  onClick={() => { setFilaAnular(row); setModalAnular(true); }}
                                  icon={<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={IOS.red} strokeWidth="2" strokeLinecap="round"><polyline points="3 6 5 6 21 6" /><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" /><path d="M10 11v6M14 11v6" /><path d="M9 6V4h6v2" /></svg>} />
                              </Box>
                            </td>
                          </tr>
                        );
                      })
                    }
                  </tbody>
                </table>
              </Box>

              {datos.length > 0 && <Paginacion total={datosFiltrados.length} pagina={pagina} setPagina={setPagina} rpp={rpp} setRpp={setRpp} />}
            </Box>
          }
        </Box>
      </Box>

      {/* Modal Resumen */}
      <Modal open={modalResumen} onClose={() => setModalResumen(false)} w="92vw">
        <ModalHeader title={`Resumen — Conteo #${filaSelec?.FCD_ID}`} onClose={() => setModalResumen(false)} color={IOS.blue} badge={resumen.length}
          icon={<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={IOS.blue} strokeWidth="2" strokeLinecap="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" /><circle cx="12" cy="12" r="3" /></svg>} />
        {filaSelec && (
          <Box className="pharmacy-layout" sx={{ px: 2.5, py: 1.5, bgcolor: IOS.bg, borderBottom: `1px solid ${IOS.separator}`, flexShrink: 0, display: 'flex', gap: 3, flexWrap: 'wrap', alignItems: 'center' }}>
            {[['Tipo', filaSelec.TIPO], ['Usuario', filaSelec.USUARIO_INTEGRA], ['Fecha', filaSelec.FECHA_CONSULTADA], ['Estado', filaSelec.ESTADO]].map(([l, v]) => (
              <Box key={l}>
                <Typography sx={{ fontSize: '0.72rem', fontWeight: 700, color: IOS.label2, textTransform: 'uppercase', letterSpacing: '0.06em' }}>{l}</Typography>
                <Typography sx={{ fontSize: '0.8rem', fontWeight: 600, color: IOS.label }}>{v}</Typography>
              </Box>
            ))}
            <Box sx={{ ml: 'auto', position: 'relative' }}>
              <Box sx={{ position: 'absolute', left: 9, top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none', color: IOS.label2 }}>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><circle cx="11" cy="11" r="8" /><path d="M21 21l-4.35-4.35" /></svg>
              </Box>
              <input aria-label="Buscar producto" placeholder="Buscar producto..." value={busqRes} onChange={e => setBusqRes(e.target.value)}
                style={{ height: 32, width: 200, paddingLeft: 26, paddingRight: 10, border: `1px solid ${IOS.separator}`, borderRadius: 8, fontSize: '0.78rem', color: IOS.label, backgroundColor: IOS.surface, outline: 'none', fontFamily: 'inherit', boxSizing: 'border-box' }}
                onFocus={e => e.target.style.borderColor = IOS.blue}
                onBlur={e => e.target.style.borderColor = IOS.separator} />
            </Box>
          </Box>
        )}
        <Box sx={{ flex: 1, overflowY: 'auto', '&::-webkit-scrollbar': { width: 3 }, '&::-webkit-scrollbar-thumb': { bgcolor: IOS.separator, borderRadius: 4 } }}>
          {cargRes
            ? <Box sx={{ py: 6, textAlign: 'center' }}><CircularProgress size={24} sx={{ color: IOS.blue }} /></Box>
            : <Box sx={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: 600, fontSize: '0.75rem' }}>
                <colgroup>
                  <col style={{ width: 90 }} /><col /><col style={{ width: 100 }} />
                  <col style={{ width: 110 }} /><col style={{ width: 110 }} /><col style={{ width: 110 }} /><col style={{ width: 110 }} />
                </colgroup>
                <thead><tr>
                  <TH>Código</TH><TH>Producto</TH><TH>FF</TH>
                  <TH right>Saldo Ant.</TH><TH right>Ingresos</TH>
                  <TH right>Salidas</TH><TH right>Stock</TH>
                </tr></thead>
                <tbody>
                  {resumenFiltrado.length === 0
                    ? <tr><td colSpan={7} style={{ padding: '24px', textAlign: 'center', color: IOS.label2, fontSize: '0.78rem' }}>Sin datos</td></tr>
                    : resumenFiltrado.map((r, i) => (
                      <tr key={i} style={{ borderBottom: `1px solid ${IOS.separator}`, backgroundColor: IOS.surface, transition: 'background 0.1s' }}
                        onMouseEnter={e => e.currentTarget.style.backgroundColor = IOS.bg}
                        onMouseLeave={e => e.currentTarget.style.backgroundColor = IOS.surface}>
                        <td style={{ padding: '9px 12px', fontFamily: 'monospace', color: IOS.label2, fontSize: '0.75rem' }}>{r.CODIGO}</td>
                        <td style={{ padding: '9px 12px', color: IOS.label, fontSize: '0.78rem' }}>{r.PRODUCTO}</td>
                        <td style={{ padding: '9px 12px', color: IOS.label2, fontSize: '0.75rem' }}>{r.FF}</td>
                        <td style={{ padding: '9px 12px', textAlign: 'right', color: IOS.label, fontSize: '0.78rem' }}>{Number(r.SALDO_ANTERIOR).toFixed(0)}</td>
                        <td style={{ padding: '9px 12px', textAlign: 'right', color: IOS.green, fontWeight: 700, fontSize: '0.78rem' }}>{Number(r.INGRESOS).toFixed(0)}</td>
                        <td style={{ padding: '9px 12px', textAlign: 'right', color: IOS.red, fontWeight: 700, fontSize: '0.78rem' }}>{Number(r.SALIDAS).toFixed(0)}</td>
                        <td style={{ padding: '9px 12px', textAlign: 'right', color: IOS.blue, fontWeight: 700, fontSize: '0.78rem' }}>{Number(r.STOCK).toFixed(0)}</td>
                      </tr>
                    ))
                  }
                </tbody>
                {resumenFiltrado.length > 0 && (
                  <tfoot>
                    <tr style={{ backgroundColor: '#374151', borderTop: `2px solid ${IOS.separator}` }}>
                      <td colSpan={3} style={{ padding: '10px 12px', fontSize: '0.78rem', fontWeight: 700, color: 'white' }}>TOTALES — {resumenFiltrado.length} productos</td>
                      <td style={{ padding: '10px 12px', textAlign: 'right', fontSize: '0.78rem', fontWeight: 800, color: 'white' }}>—</td>
                      <td style={{ padding: '10px 12px', textAlign: 'right', fontSize: '0.78rem', fontWeight: 800, color: '#6ee7b7' }}>{totRes.INGRESOS.toFixed(0)}</td>
                      <td style={{ padding: '10px 12px', textAlign: 'right', fontSize: '0.78rem', fontWeight: 800, color: '#fca5a5' }}>{totRes.SALIDAS.toFixed(0)}</td>
                      <td style={{ padding: '10px 12px', textAlign: 'right', fontSize: '0.78rem', fontWeight: 800, color: '#93c5fd' }}>{totRes.STOCK.toFixed(0)}</td>
                    </tr>
                  </tfoot>
                )}
              </table>
            </Box>
          }
        </Box>
      </Modal>

      {/* Modal PDF completo */}
      {modalPrint && (
        <Dialog open={modalPrint} onClose={() => { setModalPrint(false); setPdfUrl(null); }} maxWidth={false} aria-label="Vista previa del reporte de conteo" PaperProps={{className:"pharmacy-page conteo-page conteo-dialog",sx:{width:"92vw",maxWidth:1100,m:1.5,borderRadius:"24px"}}} sx={{ position: 'fixed', inset: 0, zIndex: 9999, bgcolor: 'rgba(0,0,0,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2, backdropFilter: 'blur(4px)' }}
          >
          <Box className="pharmacy-modal-panel pharmacy-layout pharmacy-card" onClick={e => e.stopPropagation()}
            sx={{ bgcolor: IOS.surface, borderRadius: '20px', overflow: 'hidden', width: '92vw', maxWidth: 1100, height: '92vh', display: 'flex', flexDirection: 'column', boxShadow: '0 24px 60px rgba(0,0,0,0.4)' }}>
            <Box className="pharmacy-layout" sx={{ px: 2.5, pt: 2, pb: 1.5, borderBottom: `1px solid ${IOS.separator}`, flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <Box>
                <Typography sx={{ fontWeight: 700, fontSize: '0.9rem', color: IOS.label }}>Reporte de Conteo #{filaSelec?.FCD_ID}</Typography>
                <Typography sx={{ fontSize: '0.72rem', color: IOS.label2 }}>{filaSelec?.TIPO} · {filaSelec?.FECHA_CONSULTADA} · {filaSelec?.USUARIO_INTEGRA}</Typography>
              </Box>
              <Box className="pharmacy-layout" sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                {pdfUrl && (
                  <Box className="pharmacy-layout" component="a" href={pdfUrl} download={`Conteo_${filaSelec?.FCD_ID}.pdf`}
                    sx={{ height: 32, px: 1.5, borderRadius: '10px', border: `1px solid ${IOS.green}30`, bgcolor: `${IOS.green}08`, cursor: 'pointer', color: IOS.green, fontWeight: 700, fontSize: '0.78rem', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 0.5, '&:hover': { bgcolor: `${IOS.green}14` } }}>
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke={IOS.green} strokeWidth="2" strokeLinecap="round"><path d="M12 3v13M7 11l5 5 5-5" /><path d="M4 20h16" /></svg>
                    Descargar
                  </Box>
                )}
                <Box className="pharmacy-layout pharmacy-action" component="button" aria-label="Cerrar vista previa" onClick={() => { setModalPrint(false); setPdfUrl(null); }}
                  sx={{ width: 30, height: 30, borderRadius: '50%', border: 'none', bgcolor: '#E5E5EA', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', '&:hover': { bgcolor: '#D1D1D6' } }}>
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={IOS.label} strokeWidth="2.5" strokeLinecap="round"><path d="M18 6L6 18M6 6l12 12" /></svg>
                </Box>
              </Box>
            </Box>
            <Box sx={{ flex: 1, overflow: 'hidden', bgcolor: '#525659' }}>
              {cargDet
                ? <Box className="pharmacy-layout" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', gap: 2 }}>
                  <CircularProgress sx={{ color: 'white' }} />
                  <Typography sx={{ color: 'rgba(255,255,255,0.8)', fontSize: '0.85rem' }}>Generando reporte...</Typography>
                </Box>
                : pdfUrl
                  ? <iframe src={pdfUrl} style={{ width: '100%', height: '100%', border: 'none' }} title="Reporte PDF" />
                  : <Box className="pharmacy-layout" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                    <Typography sx={{ color: 'rgba(255,255,255,0.6)' }}>No se pudo generar el reporte</Typography>
                  </Box>
              }
            </Box>
          </Box>
        </Dialog>
      )}

      {/* Modal Anular */}
      <Modal open={modalAnular && !!filaAnular} onClose={() => !anulando && setModalAnular(false)} w={380}>
        <ModalHeader title="Confirmar Anulación" onClose={() => !anulando && setModalAnular(false)} color={IOS.red}
          icon={<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={IOS.red} strokeWidth="2" strokeLinecap="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" /><line x1="12" y1="9" x2="12" y2="13" /><line x1="12" y1="17" x2="12.01" y2="17" /></svg>} />
        <Box sx={{ p: 2.5 }}>
          <Typography sx={{ color: IOS.label, fontSize: '0.85rem', mb: 2, lineHeight: 1.6 }}>
            ¿Deseas anular el conteo <strong>#{filaAnular?.FCD_ID}</strong> del <strong>{filaAnular?.FECHA_CONSULTADA}</strong>?
          </Typography>
          <Box sx={{ p: 1.5, bgcolor: '#FFF0EF', borderRadius: '10px', border: '1px solid #FFD4D1', mb: 2.5 }}>
            <Box className="pharmacy-layout" sx={{ display: 'flex', alignItems: 'center', gap: 0.6 }}>
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#C0392B" strokeWidth="2" strokeLinecap="round" style={{ flexShrink: 0 }}><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
              <Typography sx={{ fontSize: '0.76rem', color: '#C0392B', fontWeight: 600 }}>Esta acción no se puede deshacer</Typography>
            </Box>
          </Box>
          <Box className="pharmacy-layout" sx={{ display: 'flex', gap: 1.5 }}>
            <Box className="pharmacy-action" component="button" onClick={() => !anulando && setModalAnular(false)}
              sx={{ flex: 1, height: 36, borderRadius: '10px', border: `1px solid ${IOS.separator}`, bgcolor: IOS.surface, cursor: 'pointer', fontSize: '0.82rem', fontWeight: 600, color: IOS.label2 }}>
              Cancelar
            </Box>
            <Box className="pharmacy-layout pharmacy-action" component="button" onClick={confirmarAnular} disabled={anulando}
              sx={{ flex: 1, height: 36, borderRadius: '10px', border: 'none', bgcolor: anulando ? '#E5E5EA' : IOS.red, cursor: anulando ? 'default' : 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.8, transition: 'all 0.15s' }}>
              {anulando && <Box sx={{ width: 12, height: 12, borderRadius: '50%', border: '2px solid rgba(255,255,255,0.3)', borderTopColor: 'white', animation: 'spin 0.8s linear infinite', '@keyframes spin': { '0%': { transform: 'rotate(0deg)' }, '100%': { transform: 'rotate(360deg)' } } }} />}
              <Typography sx={{ fontSize: '0.82rem', fontWeight: 700, color: anulando ? '#8E8E93' : 'white' }}>{anulando ? 'Anulando...' : 'Sí, anular'}</Typography>
            </Box>
          </Box>
        </Box>
      </Modal>

      {/* ── Modal Dividir entre químicos ── */}
      <ModalDividir
        open={modalDividir}
        onClose={() => setModalDividir(false)}
        fila={filaDividir}
        ueId={ueId}
        onPdfGenerado={(url, fila) => {
          setFilaSelec(fila);
          setPdfUrl(url);
          setCargDet(false);
          setModalPrint(true);
        }}
      />
    </>
  );
};

export default ReporteConteo;
